import React from "react";
import student from "../../../assets/student.jpg";
import Step2 from "../../../assets/step2.png";
import employer from "../../../assets/employer.svg";
import Step1 from "../../../assets/step1.png";
import visitor from "../../../assets/visitor.svg";
import labour from "../../../assets/labour.webp";
import skills from "../../../assets/skills.svg";
import dama from "../../../assets/dama.svg";
import ArtVisaAppeals from "../../../assets/ArtVisaAppeals.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Services = () => {
  return (
    <section id="services" className="section alt-bg mt-3">
      <div className="container">
        <div className="margin-60px">
          <div className="w-dyn-list">
            <div role="list" className="insurance-grid w-dyn-items mx-auto">
              <div role="listitem" className="w-dyn-item">
                <div
                  data-w-id="74467288-2f25-2463-79e8-621748bb1b86"
                  className="step-box"
                >
                  <div className="step-circle-icon">
                    <img
                      loading="lazy"
                      src={student}
                      alt=""
                      className="small-icon"
                    />
                  </div>
                  <h3 className="step-title">Student Visas</h3>
                  <div>
                    <p>
                      At Win Migration Group provides expert assistance for
                      Student Visa (Subclass 500) applications, ensuring a
                      stress-free process. We help you choose the right course
                      and institution, secure your Confirmation of Enrolment
                      (CoE), and prepare essential documents like financial
                      proofs, GTE statements, and health insurance (OSHC). Our
                      team guides you through the visa application process from
                      start to finish, helping you achieve your Australian
                      education goals with ease.
                    </p>
                  </div>
                  <div className="margin-20px">
                    <Link
                      to="StudentVisas"
                      className="button-underline w-inline-block"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                    <Link
                      to="StudentVisas"
                      className="button-underline w-inline-block w-condition-invisible"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              
              <div role="listitem" className="w-dyn-item">
                <div
                  data-w-id="74467288-2f25-2463-79e8-621748bb1b86"
                  className="step-box"
                >
                  <div className="step-circle-icon">
                    <img
                      loading="lazy"
                      src={Step2}
                      alt=""
                      className="small-icon"
                    />
                  </div>
                  <h3 className="step-title">Skilled Visas</h3>
                  <div>
                    <p>
                      Australia’s Skilled Visa Program is designed to attract
                      talented individuals and families with the expertise to
                      contribute to the country’s economic growth. These visas
                      aim to address critical skill shortages across various
                      industries, ensuring Australia continues to thrive while
                      offering skilled professionals an opportunity to live,
                      work, and build a life in one of the world’s most dynamic
                      and diverse nations.
                    </p>
                  </div>
                  <div className="margin-20px">
                    <Link
                      to="SkilledVisas"
                      className="button-underline w-inline-block"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                    <Link
                      to="SkilledVisas"
                      className="button-underline w-inline-block w-condition-invisible"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div role="listitem" className="w-dyn-item">
                <div
                  data-w-id="74467288-2f25-2463-79e8-621748bb1b86"
                  className="step-box"
                >
                  <div className="step-circle-icon">
                    <img
                      loading="lazy"
                      src={employer}
                      alt=""
                      className="small-icon"
                    />
                  </div>
                  <h3 className="step-title">Employer-Sponsored Visas</h3>
                  <div>
                    <p>
                      These visas provide Australian employers with the
                      opportunity to bring skilled overseas workers to live and
                      work in Australia, helping businesses address critical
                      skill shortages while driving
                    </p>
                  </div>
                  <div className="margin-20px">
                    <Link
                      to="EmployerVisas"
                      className="button-underline w-inline-block"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                    <Link
                      to="EmployerVisas"
                      className="button-underline w-inline-block w-condition-invisible"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div role="listitem" className="w-dyn-item">
                <div
                  data-w-id="74467288-2f25-2463-79e8-621748bb1b86"
                  className="step-box"
                >
                  <div className="step-circle-icon">
                    <img
                      loading="lazy"
                      src={Step1}
                      alt=""
                      className="small-icon"
                    />
                  </div>
                  <h3 className="step-title">Family And Partner Visas</h3>
                  <div>
                    <p>
                      Australia offers a range of visa options to help citizens,
                      permanent residents, and eligible New Zealand citizens
                      bring their loved ones to join them. Whether you're
                      looking to reunite with a partner, child, or parent,
                      understanding the available visas and their requirements
                      is essential.
                    </p>
                  </div>
                  <div className="margin-20px">
                    <Link
                      to="FamilyVisas"
                      className="button-underline w-inline-block"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                    <Link
                      to="FamilyPartnerVisas"
                      className="button-underline w-inline-block w-condition-invisible"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div role="listitem" className="w-dyn-item">
                <div
                  data-w-id="74467288-2f25-2463-79e8-621748bb1b86"
                  className="step-box"
                >
                  <div className="step-circle-icon">
                    <img
                      loading="lazy"
                      src={visitor}
                      alt=""
                      className="small-icon"
                    />
                  </div>
                  <h3 className="step-title">Visitor Visas</h3>
                  <div>
                    <p>
                      Visitor visas allow you and your family to travel to
                      Australia for holidays, family visits, business
                      activities, or even short-term studies or conferences.
                      These visas are an essential gateway for people worldwide
                      to experience Australia's stunning landscapes, vibrant
                      cities, and rich culture. They also enable meaningful
                      family reunions and opportunities for business networking
                      or cultural exchange.
                    </p>
                  </div>
                  <div className="margin-20px">
                    <Link
                      to="VisitorVisas"
                      className="button-underline w-inline-block"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                    <Link
                      to="VisitorVisas"
                      className="button-underline w-inline-block w-condition-invisible"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div role="listitem" className="w-dyn-item">
                <div
                  data-w-id="74467288-2f25-2463-79e8-621748bb1b86"
                  className="step-box"
                >
                  <div className="step-circle-icon">
                    <img
                      loading="lazy"
                      src={labour}
                      alt=""
                      className="small-icon"
                    />
                  </div>
                  <h3 className="step-title">Labour Agreements</h3>
                  <div>
                    <p>
                      Labour agreements are formal arrangements between the
                      Australian Government and employers, allowing businesses
                      to sponsor skilled overseas workers for positions that
                      cannot be filled by the local labour market. These
                      agreements are tailored to address specific industry or
                      regional labour shortages and include:
                    </p>
                  </div>
                  <div className="margin-20px">
                    <Link
                      to="LabourAgreements"
                      className="button-underline w-inline-block"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                    <Link
                      to="LabourAgreements"
                      className="button-underline w-inline-block w-condition-invisible"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div role="listitem" className="w-dyn-item">
                <div
                  data-w-id="74467288-2f25-2463-79e8-621748bb1b86"
                  className="step-box"
                >
                  <div className="step-circle-icon">
                    <img
                      loading="lazy"
                      src={skills}
                      alt=""
                      className="small-icon"
                    />
                  </div>
                  <h3 className="step-title">Skills Assessment</h3>
                  <div>
                    <p>
                      A skills assessment is a process that verifies your
                      skills, qualifications, and work experience for your
                      nominated occupation. For most skilled visas, your
                      occupation must be on one of Australia’s skilled
                      occupation lists, and the relevant authority must evaluate
                      your credentials.
                    </p>
                  </div>
                  <div className="margin-20px">
                    <Link
                      to="SkillsAssessment"
                      className="button-underline w-inline-block"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                    <Link
                      to="LabourAssessments"
                      className="button-underline w-inline-block w-condition-invisible"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div role="listitem" className="w-dyn-item">
                <div
                  data-w-id="74467288-2f25-2463-79e8-621748bb1b86"
                  className="step-box"
                >
                  <div className="step-circle-icon">
                    <img
                      loading="lazy"
                      src={dama}
                      alt=""
                      className="small-icon"
                    />
                  </div>
                  <h3 className="step-title">
                    Designated Area Migration Agreement (DAMA)
                  </h3>
                  <div>
                    <p>
                      The Designated Area Migration Agreement (DAMA) is a
                      tailored migration program designed to address specific
                      labour shortages in regional Australia. It enables
                      employers in designated areas to sponsor skilled and
                      semi-skilled overseas workers for positions that cannot be
                      filled locally, thereby supporting economic growth and
                      community development.
                    </p>
                  </div>
                  <div className="margin-20px">
                    <Link to="DAMA" className="button-underline w-inline-block">
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                    <Link
                      to="DAMA"
                      className="button-underline w-inline-block w-condition-invisible"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>

              <div role="listitem" className="w-dyn-item">
                <div
                  data-w-id="74467288-2f25-2463-79e8-621748bb1b86"
                  className="step-box"
                >
                  <div className="step-circle-icon">
                    <img
                      loading="lazy"
                      src={ArtVisaAppeals}
                      alt=""
                      className="small-icon"
                    />
                  </div>
                  <h3 className="step-title">ART Visa Appeals </h3>
                  <div>
                    <p>
                      The Administrative Review Tribunal is responsible for
                      reviewing decisions made by the Department of Home
                      Affairs, including visa refusals, cancellations, and
                      citizenship issues. The ART has two primary divisions
                      handling migration matters:
                    </p>
                  </div>
                  <div className="margin-20px">
                    <Link
                      to="ArtVisaAppeals"
                      className="button-underline w-inline-block"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                    <Link
                      to="LabourAssessments"
                      className="button-underline w-inline-block w-condition-invisible"
                    >
                      <div className="button-color">Get started</div>
                      <div className="line-animation">
                        <div className="underline"></div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
